<template>
  <div>
    <div
      :class="{
        'pa-2 mb-2': true,
        'red white--text': expired,
        'green white--text': !expired
      }"
      v-if="data.isSpecialSale"
    >
      <p class="mb-0 font-weight-bold text-xs-center">
        {{ expired ? 'PROMOCIÓN EXPIRADA' : 'PROMOCIÓN VIGENTE' }}
      </p>
    </div>
    <div class="grey lighten-3 pa-2 mb-2">
      <p class="mb-0">
        <small class="primary--text">Presupuesto solicitado el</small><br />
        {{ $moment(data.created_at).format('D MMM YYYY HH:mm') }}
      </p>
    </div>
    <div class="grey lighten-3 pa-2 mb-2" v-if="data.isSpecialSale">
      <p class="mb-0">
        <small class="primary--text">Oferta válida hasta el</small><br />
        {{ $moment(data.special_sale.expires_at).format('D MMM YYYY HH:mm') }}
      </p>
    </div>
    <div class="grey lighten-3 pa-2 mb-2">
      <p class="mb-0">
        <small class="primary--text">Estado</small><br />
        {{ data.quoted ? 'Presupuesto Completado' : 'Presupuesto Solicitado' }}
      </p>
    </div>
    <div class="grey lighten-3 pa-2 mb-2">
      <p>
        <small class="primary--text">Solicitado por</small><br />
        {{ data.user.first_name || '---' }}
        {{ data.user.last_name || '---' }}
        {{ data.user.mother_last_name || '---' }}
      </p>
      <p>
        <small class="primary--text">Rut</small><br />
        {{ data.user.dni | rut }}
      </p>
      <p>
        <small class="primary--text">Email</small><br />
        {{ data.user.email || '---' }}
      </p>
      <p>
        <small class="primary--text">Teléfonos</small><br />
        {{ data.user.phone1 | phone_format }}
      </p>
    </div>
    <div class="grey lighten-3 pa-2 mb-2" v-if="data.isServiceItem">
      <p class="mb-0">
        <small class="primary--text">Solicitud por</small><br />
        {{ service.serviceName }} |
        {{ data.service_items[0].description }}
      </p>
    </div>
    <div
      class="grey lighten-3 pa-2 mb-2"
      style="position:relative;"
      v-if="data.isSpecialSale"
    >
      <p class="mb-0 discount">-{{ data.special_sale.discount }}%</p>
      <p class="mb-0 pl-5 ml-2">
        <small class="primary--text">Promoción por</small><br />
        {{ service.fullName }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      service: '',
      expired: false
    }
  },
  mounted() {
    if (this.data.isSpecialSale) {
      this.service = this.services.find(
        el => el.serviceItemId === this.data.special_sale.service_item.id
      )
      const today = this.$moment()
      const expires = this.$moment(this.data.special_sale.expires_at)
      const expired = expires.diff(today)
      expired <= 0 ? (this.expired = true) : (this.expired = false)
    } else if (this.data.isServiceItem) {
      this.service = this.services.find(
        el => el.serviceItemId === this.data.service_items[0].id
      )
    }
  }
}
</script>
<style scoped>
.discount {
  position: absolute;
  top: 9px;
  left: 0;
  background-color: red;
  color: white;
  font-weight: 700;
  font-size: 20px;
  padding: 5px 7px;
}
</style>